// import React, { useEffect } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import {
//   fetchCategoryAddonMappings,
//   fetchMenuItemAddonMappings,
//   clearMenuItemAddonMappings,
// } from "../../redux/action";

// function MenuItemAddonSection({ categoryId, menuId, itemOverrides, setItemOverrides }) {
//   const dispatch = useDispatch();

//   const allMasterAddons = useSelector((state) => state.admin?.addonGroups) || [];
//   const categoryAddonIds = useSelector((state) => state.admin?.categoryAddonGroupIds) || [];
//   const serverItemMappings = useSelector((state) => state.admin?.menuItemAddonMappings) || [];

//   // 1. Fetch category addons when categoryId changes
//   useEffect(() => {
//     if (categoryId && categoryId !== "0") {
//       dispatch(fetchCategoryAddonMappings(categoryId));
//     }
//   }, [categoryId, dispatch]);

//   // 2. Fetch dish overrides if editing dish
//   useEffect(() => {
//     if (menuId && menuId !== "00000000-0000-0000-0000-000000000000") {
//       dispatch(fetchMenuItemAddonMappings(menuId));
//     }
//     return () => {
//       dispatch(clearMenuItemAddonMappings());
//     };
//   }, [menuId, dispatch]);

//   // 3. Sync server mappings into parent local form state
//   useEffect(() => {
//     if (serverItemMappings && serverItemMappings.length > 0) {
//       setItemOverrides(
//         serverItemMappings.map((m) => ({
//           addonGroupId: m.addonGroupId,
//           isExcluded: m.isExcluded,
//         }))
//       );
//     }
//   }, [serverItemMappings, setItemOverrides]);

//   // Toggle Inherited Addon (Exclude / Include)
//   const handleToggleInherited = (groupId) => {
//     const existing = itemOverrides.find((o) => o.addonGroupId === groupId);
//     if (existing) {
//       setItemOverrides(itemOverrides.filter((o) => o.addonGroupId !== groupId));
//     } else {
//       setItemOverrides([...itemOverrides, { addonGroupId: groupId, isExcluded: true }]);
//     }
//   };

//   // Toggle Item-Specific Addon (Add / Remove custom group)
//   const handleToggleItemSpecific = (groupId) => {
//     const existing = itemOverrides.find((o) => o.addonGroupId === groupId);
//     if (existing && !existing.isExcluded) {
//       setItemOverrides(itemOverrides.filter((o) => o.addonGroupId !== groupId));
//     } else {
//       const filtered = itemOverrides.filter((o) => o.addonGroupId !== groupId);
//       setItemOverrides([...filtered, { addonGroupId: groupId, isExcluded: false }]);
//     }
//   };

//   const inheritedGroups = allMasterAddons.filter((g) =>
//     categoryAddonIds.includes(g.addonGroupId)
//   );

//   const extraGroups = allMasterAddons.filter(
//     (g) => !categoryAddonIds.includes(g.addonGroupId)
//   );

//   return (
//     <div style={containerStyle}>
//       <h4 style={{ margin: "0 0 10px 0", fontSize: "14px", color: "#1f2937" }}>
//         Add-ons Configuration (Optional)
//       </h4>

//       {/* 1. Category Inherited Add-ons */}
//       <div style={sectionBoxStyle}>
//         <span style={sectionTitleStyle}>Inherited from Category:</span>
//         {inheritedGroups.length === 0 ? (
//           <p style={emptyTextStyle}>No add-ons mapped to this category.</p>
//         ) : (
//           <div style={chipsContainerStyle}>
//             {inheritedGroups.map((group) => {
//               const isExcluded = itemOverrides.some(
//                 (o) => o.addonGroupId === group.addonGroupId && o.isExcluded
//               );
//               return (
//                 <div
//                   key={group.addonGroupId}
//                   onClick={() => handleToggleInherited(group.addonGroupId)}
//                   style={inheritedChipStyle(isExcluded)}
//                 >
//                   <span style={{ fontWeight: "600" }}>{group.groupName}</span>
//                   <span style={statusBadgeStyle(isExcluded)}>
//                     {isExcluded ? "✕ Excluded" : "✓ Active"}
//                   </span>
//                 </div>
//               );
//             })}
//           </div>
//         )}
//       </div>

//       {/* 2. Extra Dish-Specific Add-ons */}
//       {extraGroups.length > 0 && (
//         <div style={{ ...sectionBoxStyle, marginTop: "12px" }}>
//           <span style={sectionTitleStyle}>Dish-Specific Add-ons:</span>
//           <div style={chipsContainerStyle}>
//             {extraGroups.map((group) => {
//               const isAdded = itemOverrides.some(
//                 (o) => o.addonGroupId === group.addonGroupId && !o.isExcluded
//               );
//               return (
//                 <div
//                   key={group.addonGroupId}
//                   onClick={() => handleToggleItemSpecific(group.addonGroupId)}
//                   style={extraChipStyle(isAdded)}
//                 >
//                   <span>{group.groupName}</span>
//                   <span style={{ fontSize: "11px", fontWeight: "bold" }}>
//                     {isAdded ? "✓ Added" : "+ Add"}
//                   </span>
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// const containerStyle = {
//   border: "1px solid #e5e7eb",
//   borderRadius: "8px",
//   padding: "14px",
//   backgroundColor: "#f9fafb",
//   marginBottom: "18px",
// };

// const sectionBoxStyle = {
//   display: "flex",
//   flexDirection: "column",
//   gap: "6px",
// };

// const sectionTitleStyle = {
//   fontSize: "13px",
//   fontWeight: "600",
//   color: "#4b5563",
// };

// const emptyTextStyle = {
//   fontSize: "12px",
//   color: "#9ca3af",
//   margin: "4px 0",
// };

// const chipsContainerStyle = {
//   display: "flex",
//   flexWrap: "wrap",
//   gap: "8px",
//   marginTop: "4px",
// };

// const inheritedChipStyle = (isExcluded) => ({
//   display: "flex",
//   alignItems: "center",
//   gap: "8px",
//   padding: "6px 12px",
//   borderRadius: "20px",
//   fontSize: "13px",
//   cursor: "pointer",
//   backgroundColor: isExcluded ? "#fee2e2" : "#dcfce7",
//   border: `1px solid ${isExcluded ? "#f87171" : "#86efac"}`,
//   color: isExcluded ? "#991b1b" : "#166534",
//   transition: "all 0.2s ease",
// });

// const extraChipStyle = (isAdded) => ({
//   display: "flex",
//   alignItems: "center",
//   gap: "8px",
//   padding: "6px 12px",
//   borderRadius: "20px",
//   fontSize: "13px",
//   cursor: "pointer",
//   backgroundColor: isAdded ? "#e0f2fe" : "#ffffff",
//   border: `1px solid ${isAdded ? "#38bdf8" : "#d1d5db"}`,
//   color: isAdded ? "#0369a1" : "#4b5563",
//   transition: "all 0.2s ease",
// });

// const statusBadgeStyle = (isExcluded) => ({
//   fontSize: "11px",
//   fontWeight: "700",
//   padding: "1px 6px",
//   borderRadius: "10px",
//   backgroundColor: isExcluded ? "#ef4444" : "#22c55e",
//   color: "#fff",
// });

// export default MenuItemAddonSection;

import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchCategoryAddonMappings,
  fetchMenuItemAddonMappings,
  clearMenuItemAddonMappings,
  clearCategoryAddonMappings,
} from "../../redux/action";
import { SectionLoader } from "../../component/common/Loader";

function MenuItemAddonSection({ categoryId, menuId, itemOverrides = [], setItemOverrides }) {
  const dispatch = useDispatch();

  const rawMasterAddons = useSelector((state) => state.admin?.addonGroups) || [];
  const rawCategoryAddonIds = useSelector((state) => state.admin?.categoryAddonGroupIds) || [];
  const serverItemMappings = useSelector((state) => state.admin?.menuItemAddonMappings) || [];
  const addonGroupsLoading = useSelector((state) => Boolean(state.admin?.addonGroupsLoading));
  const categoryMappingsLoading = useSelector((state) => Boolean(state.admin?.categoryAddonMappingsLoading));
  const categoryMappingsFor = useSelector((state) => state.admin?.categoryAddonMappingsFor);
  const itemMappingsLoading = useSelector((state) => Boolean(state.admin?.menuItemAddonMappingsLoading));
  const itemMappingsFor = useSelector((state) => state.admin?.menuItemAddonMappingsFor);
  const allMasterAddons = Array.isArray(rawMasterAddons) ? rawMasterAddons : [];
  const normalizedCategoryId = String(categoryId || "").toLowerCase();
  const normalizedMenuId = String(menuId || "").toLowerCase();

  useEffect(() => {
    dispatch({ type: "FETCH_ADDON_GROUPS" });
  }, [dispatch]);

  // 1. Normalize Category Addon IDs (guid string array)
  const categoryAddonIds = (Array.isArray(rawCategoryAddonIds) ? rawCategoryAddonIds : [])
    .map((id) => (typeof id === "string" ? id.toLowerCase() : id?.addonGroupId?.toLowerCase() || ""));

  // 2. Fetch category addons when categoryId changes
  useEffect(() => {
    if (categoryId && categoryId !== "0" && categoryId !== "00000000-0000-0000-0000-000000000000") {
      dispatch(fetchCategoryAddonMappings(categoryId));
    } else {
      dispatch(clearCategoryAddonMappings());
    }
    return () => dispatch(clearCategoryAddonMappings());
  }, [categoryId, dispatch]);

  // 3. Fetch dish overrides if editing dish
  useEffect(() => {
    if (menuId && menuId !== "00000000-0000-0000-0000-000000000000") {
      dispatch(fetchMenuItemAddonMappings(menuId));
    } else {
      dispatch(clearMenuItemAddonMappings());
    }
    return () => {
      dispatch(clearMenuItemAddonMappings());
    };
  }, [menuId, dispatch]);

  // 4. Sync server mappings into parent local form state
  useEffect(() => {
    const responseMatchesItem = normalizedMenuId
      && String(itemMappingsFor || "").toLowerCase() === normalizedMenuId;
    if (!itemMappingsLoading && responseMatchesItem) {
      setItemOverrides(
        serverItemMappings.map((m) => ({
          addonGroupId: m.addonGroupId,
          isExcluded: m.isExcluded,
        }))
      );
    }
  }, [itemMappingsFor, itemMappingsLoading, normalizedMenuId, serverItemMappings, setItemOverrides]);

  // ⭐ Toggle Category Inherited Group (Exclude / Re-include)
  const handleToggleInherited = (groupId) => {
    const existing = itemOverrides.find(
      (o) => o.addonGroupId.toLowerCase() === groupId.toLowerCase()
    );
    const filtered = itemOverrides.filter(
      (o) => o.addonGroupId.toLowerCase() !== groupId.toLowerCase()
    );

    if (existing) {
      // Toggle exclusion
      setItemOverrides([
        ...filtered,
        { addonGroupId: groupId, isExcluded: !existing.isExcluded },
      ]);
    } else {
      // Pehli baar category addon ko uncheck kiya -> isExcluded: true
      setItemOverrides([
        ...filtered,
        { addonGroupId: groupId, isExcluded: true },
      ]);
    }
  };

  // ⭐ Toggle Item-Specific Group (Add / Remove)
  const handleToggleItemSpecific = (groupId) => {
    const existing = itemOverrides.find(
      (o) => o.addonGroupId.toLowerCase() === groupId.toLowerCase()
    );
    const filtered = itemOverrides.filter(
      (o) => o.addonGroupId.toLowerCase() !== groupId.toLowerCase()
    );

    if (existing && !existing.isExcluded) {
      // Uncheck dish-specific item -> mark excluded/inactive
      setItemOverrides([
        ...filtered,
        { addonGroupId: groupId, isExcluded: true },
      ]);
    } else {
      // Add dish-specific item -> active inclusion
      setItemOverrides([
        ...filtered,
        { addonGroupId: groupId, isExcluded: false },
      ]);
    }
  };

  // Split master addons into Inherited vs Dish-Specific
  const inheritedGroups = allMasterAddons.filter((g) =>
    categoryAddonIds.includes(g.addonGroupId?.toLowerCase())
  );

  const extraGroups = allMasterAddons.filter(
    (g) => !categoryAddonIds.includes(g.addonGroupId?.toLowerCase())
  );
  const mappingsMatchCategory = normalizedCategoryId
    && String(categoryMappingsFor || "").toLowerCase() === normalizedCategoryId;
  const isLoading = addonGroupsLoading
    || categoryMappingsLoading
    || (normalizedCategoryId && !mappingsMatchCategory)
    || (normalizedMenuId
      && normalizedMenuId !== "00000000-0000-0000-0000-000000000000"
      && (itemMappingsLoading || String(itemMappingsFor || "").toLowerCase() !== normalizedMenuId));

  return (
    <div style={containerStyle}>
      <h4 style={{ margin: "0 0 10px 0", fontSize: "14px", color: "var(--ui-text)" }}>
        Add-ons Configuration (Optional)
      </h4>

      {isLoading ? (
        <SectionLoader label="Loading available add-ons..." rows={2} compact />
      ) : (
        <>

      {/* 1. Category Inherited Add-ons */}
      <div style={sectionBoxStyle}>
        <span style={sectionTitleStyle}>Inherited from Category:</span>
        {inheritedGroups.length === 0 ? (
          <p style={emptyTextStyle}>No add-ons mapped to this category.</p>
        ) : (
          <div style={chipsContainerStyle}>
            {inheritedGroups.map((group) => {
              const override = itemOverrides.find(
                (o) => o.addonGroupId.toLowerCase() === group.addonGroupId.toLowerCase()
              );
              // Agar override nahi hai toh default Active (not excluded)
              const isExcluded = override ? override.isExcluded : false;

              return (
                <div
                  key={group.addonGroupId}
                  onClick={() => handleToggleInherited(group.addonGroupId)}
                  style={inheritedChipStyle(isExcluded)}
                >
                  <span style={{ fontWeight: "600" }}>{group.groupName}</span>
                  <span style={statusBadgeStyle(isExcluded)}>
                    {isExcluded ? "✕ Excluded" : "✓ Active"}
                  </span>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* 2. Extra Dish-Specific Add-ons */}
      {extraGroups.length > 0 && (
        <div style={{ ...sectionBoxStyle, marginTop: "12px" }}>
          <span style={sectionTitleStyle}>Dish-Specific Add-ons:</span>
          <div style={chipsContainerStyle}>
            {extraGroups.map((group) => {
              const override = itemOverrides.find(
                (o) => o.addonGroupId.toLowerCase() === group.addonGroupId.toLowerCase()
              );
              const isAdded = override ? !override.isExcluded : false;

              return (
                <div
                  key={group.addonGroupId}
                  onClick={() => handleToggleItemSpecific(group.addonGroupId)}
                  style={extraChipStyle(isAdded)}
                >
                  <span>{group.groupName}</span>
                  <span style={{ fontSize: "11px", fontWeight: "bold" }}>
                    {isAdded ? "✓ Added" : "+ Add"}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      )}
        </>
      )}
    </div>
  );
}

const containerStyle = {
  border: "1px solid var(--ui-border)",
  borderRadius: "8px",
  padding: "14px",
  backgroundColor: "var(--ui-surface-muted)",
  marginBottom: "18px",
};

const sectionBoxStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "6px",
};

const sectionTitleStyle = {
  fontSize: "13px",
  fontWeight: "600",
  color: "var(--ui-muted)",
};

const emptyTextStyle = {
  fontSize: "12px",
  color: "#9ca3af",
  margin: "4px 0",
};

const chipsContainerStyle = {
  display: "flex",
  flexWrap: "wrap",
  gap: "8px",
  marginTop: "4px",
};

const inheritedChipStyle = (isExcluded) => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  padding: "6px 12px",
  borderRadius: "20px",
  fontSize: "13px",
  cursor: "pointer",
  backgroundColor: isExcluded ? "#fee2e2" : "#dcfce7",
  border: `1px solid ${isExcluded ? "#f87171" : "#86efac"}`,
  color: isExcluded ? "#991b1b" : "#166534",
  transition: "all 0.2s ease",
});

const extraChipStyle = (isAdded) => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  padding: "6px 12px",
  borderRadius: "20px",
  fontSize: "13px",
  cursor: "pointer",
  backgroundColor: isAdded ? "#e0f2fe" : "#ffffff",
  border: `1px solid ${isAdded ? "#38bdf8" : "#d1d5db"}`,
  color: isAdded ? "#0369a1" : "#4b5563",
  transition: "all 0.2s ease",
});

const statusBadgeStyle = (isExcluded) => ({
  fontSize: "11px",
  fontWeight: "700",
  padding: "1px 6px",
  borderRadius: "10px",
  backgroundColor: isExcluded ? "#ef4444" : "#22c55e",
  color: "#fff",
});

export default MenuItemAddonSection;
